<template>
  <div style="width: 100%">
    <!--      第二行-->
    <div class="div2-PQI">
      <div class="div2-div1-PQI">
        <a class="div2-a1-PQI">{{introduce.title}}</a><br>
        <a class="div2-a2-PQI">发布时间：{{introduce.dateTime}} </a><br>
        <a class="div2-a2-PQI" style="font-size: xx-small">免责声明:内容来自互联网搜集,与本平台无关,如有侵权请联系平台管理员删除,我们不承担任何责任.</a>
      </div>
    </div>
    <!--      第三行-->
    <div class="div2-PQI" style="padding-bottom: 20px">
      <div class="div3-div1-PQI">
        {{introduce.details}}
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "MobileQuestionIntroduce",
    data() {
      return {
        introduce: {
          title: '病死猪',
          dateTime: '2024-04-10',
          details: '近年来，随着我国养殖业的大力发展，病死动物的处理对净化环境意义重大。病死动物干化机是病死动物无害化处理常用的主体设备。'
        },
      }
    },
    mounted() {
      this.introduce = this.$store.state.questionIntroduce;
      console.log(this.$store.state.questionIntroduce);
    },
    methods: {
      clickReturn() {
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/second/MobileQuestionIntroduce.vue